import * as vehiclesTranslationsDe from './lib/translations.de.json';
import * as vehiclesTranslationsEn from './lib/translations.en.json';

export { vehiclesTranslationsDe, vehiclesTranslationsEn };
export * from './lib/add-vehicle/AddVehicle';
export * from './lib/VehiclesPage';
export * from './lib/edit-vehicle/EditVehicle';
